export default __webpack_public_path__ + "static/media/41.820210ad.png";